import { useState, type ReactNode } from "react";
import { Button } from "../ui/Button/Button";
import styles from "./RecoveryNotice.module.css";

export default function RecoveryNotice({
  children,
  onRetry,
  action,
}: {
  children: ReactNode;
  onRetry: () => Promise<unknown>;
  action?: ReactNode;
}) {
  const [pending, setPending] = useState(false);
  const [retryFailed, setRetryFailed] = useState(false);
  return (
    <div className={styles.notice} role="status" aria-busy={pending}>
      <span className={styles.message}>
        {retryFailed
          ? "Still unavailable. Please try again shortly."
          : children}
      </span>
      <div className={styles.actions}>
        <Button
          variant="secondary"
          size="sm"
          loading={pending}
          onClick={async () => {
            if (pending) return;
            setPending(true);
            setRetryFailed(false);
            try {
              await onRetry();
            } catch {
              setRetryFailed(true);
            } finally {
              setPending(false);
            }
          }}
        >
          {pending ? "Retrying…" : "Try again"}
        </Button>
        {action}
      </div>
    </div>
  );
}
